<template>
  <div>
    <div class="space-y-4">
      <div class="flex justify-between">
        <h2 class="font-semibold uppercase text-gray-600">Riders</h2>
        <!--         <router-link
          to="/riders/add"
          class="px-4 py-2 bg-blue-500 text-white font-semibold rounded hover:bg-blue-700"
        >
          Add Rider
        </router-link> -->
      </div>

      <div>
        <div class="relative max-w-sm w-full">
          <div class="absolute inset-y-0 flex items-center px-3">
            <i class="material-icons text-gray-500">search</i>
          </div>
          <input
            class="rounded border pl-10 pr-4 py-2 w-full"
            placeholder="Search"
            @keyup="search"
          />
        </div>
      </div>

      <div class="inline-block min-w-full shadow rounded-lg mt-4">
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Name
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Email
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Contact Number
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Rating
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Image
              </th>
              <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100"></th>
            </tr>
          </thead>
          <tbody v-if="riders.length" class="relative">
            <!-- <tr v-for="(rider, index) in riders" :key="rider._id"> -->
            <tr v-for="rider in riders" :key="rider._id">
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="whitespace-no-wrap">
                  {{ rider.firstName + " " + rider.lastName }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ rider.email || "-" }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ rider.phoneNumber || "-" }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ rider.rating || "0.0" }}
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <img
                  class="rounded-full object-fill h-10 w-10"
                  v-bind:src="
                    rider.profileImage ||
                    'https://img.pngio.com/error-inoperative-invalid-none-nothing-null-void-icon-nothing-png-512_512.png'
                  "
                />
              </td>
              <td
                class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"
              >
                <!-- <div class="relative inline-block text-left">
                  <div>
                    <span class="rounded-md shadow-sm">
                      <button
                        @click="toggleDropdown(index)"
                        type="button"
                        class="inline-flex justify-center w-full rounded-md px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
                        aria-haspopup="true"
                        :aria-expanded="openDropdown === index"
                      >
                        <i class="material-icons">more_vert</i>
                      </button>
                    </span>
                  </div>
                  <transition
                    enter-active-class="transition ease-out duration-100"
                    enter-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95"
                  >
                    <div
                      v-if="openDropdown === index"
                      class="origin-top-right absolute right-0 w-56 rounded-md shadow-lg z-50"
                    >
                      <div
                        class="rounded-md bg-white shadow-xs"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="options-menu"
                      >
                        <div class="py-1"> -->
                <router-link
                  :to="`/rides?rider=${rider._id}`"
                  class="border rounded px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                  role="menuitem"
                  >Ride History</router-link
                >
                <!--
                        </div>
                        <div class="border-t border-gray-100"></div>
                        <div class="py-1">
                          <router-link
                            :to="`/riders/${rider._id}/edit`"
                            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            Edit
                          </router-link>
                        </div>
                        <div class="border-t border-gray-100"></div>
                        <div class="py-1">
                          <button
                            @click="remove(index)"
                            type="button"
                            class="w-full px-4 py-2 text-sm leading-5 text-left text-gray-700 hover:bg-red-100 hover:text-red-900 focus:outline-none focus:bg-red-100 focus:text-red-900"
                            role="menuitem"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div> -->
              </td>
            </tr>
            <div
              v-if="loading"
              class="absolute inset-0 h-full w-full flex items-center justify-center bg-black bg-opacity-25"
            >
              <i class="material-icons text-6xl spin">sync</i>
              <span class="block invisible">Loading...</span>
            </div>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="7"
                class="bg-white py-4 text-center text-gray-600 font-semibold"
              >
                <div v-if="loading" class="inline-block">
                  <i class="material-icons text-6xl spin">sync</i>
                  <span class="block invisible">Loading...</span>
                </div>
                <div v-else class="inline-block">
                  <i class="material-icons text-6xl">warning</i>
                  <span class="block">No riders found!</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-between items-end">
        <p class="text-gray-600">
          Showing <strong>{{ start }}</strong> to <strong>{{ end }}</strong> of
          <strong>{{ paginator.count }}</strong> entries
        </p>
        <div class="flex items-center space-x-4">
          <div>
            Per page:
            <select
              class="form-select"
              name="perPage"
              id="perPage"
              @change="setPerPage"
            >
              <option :selected="perPage === '10'" value="10">10</option>
              <option :selected="perPage === '25'" value="25">25</option>
              <option :selected="perPage === '50'" value="50">50</option>
              <option :selected="perPage === '100'" value="100">100</option>
            </select>
          </div>
          <div class="space-x-2 flex">
            <button
              @click="goToPrev"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_left</i>
            </button>
            <button
              v-for="page in total"
              :key="`pageLink-${page}`"
              type="button"
              class="p-2"
              :class="{
                'text-gray-500 hover:text-gray-800': currentPage !== page,
                'text-gray-900': currentPage === page,
              }"
              :disabled="currentPage === page"
              @click="goToPage(page)"
            >
              {{ page }}
            </button>
            <button
              @click="goToNext"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Pagination from "@/mixins/Pagination";

export default {
  mixins: [Pagination],
  data() {
    return {
      allRiders: [],
      openDropdown: false,
      loading: true,
      results: [],
    };
  },
  created() {
    this.getRiders();
  },
  computed: {
    riders() {
      return this.results.length ? this.results : this.allRiders;
    },
  },
  watch: {
    currentPage() {
      this.getRiders();
    },
    perPage() {
      this.currentPage === 1 ? this.getRiders() : (this.currentPage = 1);
    },
  },
  methods: {
    toggleDropdown(index) {
      if (this.openDropdown === index) {
        this.openDropdown = false;
      } else {
        this.openDropdown = index;
      }
    },
    getRiders() {
      this.loading = true;
      this.$http
        .get(`users?limit=${this.perPage}&page=${this.currentPage}`)
        .then(response => {
          this.allRiders = response.data.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count,
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    search: _.debounce(function (e) {
      if (!e.target.value.trim()) {
        this.results = [];
      }

      this.$http
        .get(`/users/search?q=${e.target.value}`)
        .then(response => {
          this.results = response.data;
        })
        .catch(err => console.log(err));
    }, 500),
    remove(index) {
      //   this.$http
      //     .delete(`/riders/${this.riders[index]._id}`)
      //     .then(response => console.log(response))
      //     .catch(err => console.log(err));
      this.riders.splice(index, 1);
      this.openDropdown = false;
    },
  },
};
</script>
